
export default {
  beforeCreate () {
    this.$vuetify.rtl = true
  }
}
